var portfolioCreate = {
	confirmBtn: "Ok",
	cancelBtn: "Annuler",
	title: "Créer un nouveau portefeuille",
	nameInputLabel: "Nom du Portefeuille",
	nameInputPlaceholder: "Veuillez entrer un nom",
	nameInputTip: "Max. 100 caractères - Caractères valides: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	currencyInputLabel: "Devise de Base du Portefeuille",
	currencyInputPlaceholder: "Veuillez choisir une devise",
	limitExceededMessage: "Limite du portefeuille dépassée.",
	currencies: {
		euro: "Euro",
		usd: "US Dollars",
		chf: "Franc Suisse",
		gbp: "Livre Britannnique",
		jpy: "Yen Japonais",
		cad: "Dollar Canadien"
	},
	validationErrors: {
		name: {
			invalidInput: "Le nom n'est pas valide. Max. 100 caractères – Caractères valides: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var fr = {
	portfolioCreate: portfolioCreate
};

export { fr as default, portfolioCreate };
